import { noop, toLower } from 'lodash';
import clsx from 'clsx';
import { t } from '@lingui/macro';
import Button from '@material-ui/core/Button';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import useStyles from './BannerStyles';
import useIsPrinting from '../../utilities/PrintUtilities';

function Banner(props) {
    const { className, type, text, onRemove = noop } = props;
    const classes = useStyles({ type });
    const isPrinting = useIsPrinting();

    return (
        <div className={clsx(classes.root, classes[toLower(type)], className)}>
            <div className={classes.icon}>
                <InfoOutlinedIcon fontSize="large" />
            </div>
            <div className={classes.text}>{t`${text}`}</div>
            {!isPrinting && (
                <div>
                    <Button onClick={onRemove}>Dismiss</Button>
                </div>
            )}
        </div>
    );
}

export default Banner;
